
import {NgModule, Component, OnInit, OnChanges, ViewEncapsulation} from '@angular/core';
import {CommonModule} from "@angular/common";
import {Input, Output,EventEmitter} from '@angular/core';
import {BrowserModule, disableDebugTools}   from '@angular/platform-browser';
import {DialogModule,ButtonModule,DropdownModule,InputTextModule} from 'primeng/primeng';
import {FormsModule, ReactiveFormsModule, FormBuilder, FormControl, Validators} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {MamAdminService} from "../service/mam_service.component";
import {PanelModule} from "primeng/components/panel/panel";
import {SelectItem} from "primeng/components/common/api";
import {User} from "../model/user";
import { URLSearchParams} from '@angular/http';
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../translate/translate.module.pipe";
import {TranslateServiceForm} from "../translate/translate.service"; // ADD THIS
import * as glob from "../service/global_url";
import { ViewChild } from '@angular/core';
import { Dropdown } from "primeng/components/dropdown/dropdown";




//dd : Dropdown

@Component({
    selector:'ex-user-dlg',
    templateUrl:'./user_dlg.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls : ['./user_dlg.component.css']

})
export class ExUserDialogComponent implements OnChanges,OnInit{
    @ViewChild('dd') drop : Dropdown;
    @Input() title:string;

    @Input() width: any;
    @Input() type : string;
    @Input() selectedCompany : any;
    @Input() disable : boolean;
    @Input() selectedDetailUser : User;
    @Input() updateDisable : boolean = false;
    @Output() onSubmit:EventEmitter<any> = new EventEmitter();

    @Output() visibleChange:EventEmitter<any> = new EventEmitter();
    addForm : any;
    _visible: boolean;

    passwordCheckResult: any;
    passw : string;
    passConfirm : string;
    passConfirmCheck : string;
    username : string;
    selectCompany : any;
    isUseOrNot : SelectItem[];

    tempItem : any[]=[];

    childItem : any[];
    selectedAttributes : any;
    typeItems : any;
    translate : TranslateServiceForm;
    insaDeptCode : any;

    private kyungnamIsTrue:boolean = glob.kyungnamIsTrue;

    @Input() get visible(): boolean {
        return this._visible;
    }

    set visible(val:boolean) {
        this._visible = val;
        this.visibleChange.emit(val);
    }

    constructor(private fb : FormBuilder, private service: MamAdminService, private logger : Logger, private _translate : TranslateServiceForm){

      this.translate = _translate;
      this.isUseOrNot = [];
      this.isUseOrNot.push({label:'Use', value:'USE'});
      this.isUseOrNot.push({label:'Not_Use', value:'NOT_USE'});

      this.addForm = this.fb.group({
        'id' : new FormControl(''),
        'username' : new FormControl('',[Validators.required,Validators.pattern( /^[a-zA-Z0-9]{1,30}$/)]),
        'membernum' : new FormControl('',[Validators.required,Validators.pattern( /^[a-zA-Z0-9_]{1,30}$/)]),
        'email' : new FormControl('',[Validators.required,Validators.pattern(/^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/)]),
        'deptName' : new FormControl(''),
        'name' : new FormControl('', [Validators.required,Validators.pattern(/^[가-힣a-zA-Z0-9_]{1,20}$/)]),
        'password' : new FormControl(''),
        'passwordConfirm' : new FormControl(''),
        'isUse' : new FormControl('', Validators.required),
        //'title' : new FormControl(''),
        'company' : new FormControl('', Validators.required),
        'deptCode' : new FormControl('')
    });

      this.logger.debug(this.addForm);
      this.insaDeptCode = [];
      this.insaDeptCode.push({label:"------------",value:''});

      this.getInsaDeptCode();

    }

    private onYes(item):void{
        var result : boolean = false;
        if(this.type == "detail") return;
        var log = this.logger;
        let dynamicAttLength :any = 0;
        Object.getOwnPropertyNames(item).forEach(
            function (val, idx, array) {
                if(item[val] && item[val].name != undefined){
                    if(val != "company"){
                        if(item[val] != null){
                            log.debug("attribute : " + ' -> ' + "name : " +item[val].name + ":" + item[val].id);
                            dynamicAttLength++;
                        }
                    }
                }
            }
        );
        if(dynamicAttLength>0){

          //여기서 처리하면서 걸러야된다.
          if(this.type=="add"){

            if(item.username.length>0){
              this.service.userNameChecker(item.username).subscribe(
                value => {
                  this.logger.debug("usernameCheck 결과 값 : ",value);
                  if(value != "OK"){
                    alert(this.translate.instant('MESSAGE_Duplicate_ID'));
                    this.visible = true;
                  }else{

                      //추가
                      if(this.passw){

                        let encodePassword = btoa(this.passw);

                        this.service.passwordChecker(encodePassword).subscribe(
                          value => {
                            this.passwordCheckResult = value;
                            this.logger.debug("-- result :", this.passwordCheckResult);
                          },
                          error => {
                            this.logger.error("-- error : " + error);
                          },
                          () => {
                            if(this.passwordCheckResult != 'OK'){
                              alert(this.passwordCheckResult);
                              this.visible = true;
                              //this.logger.debug("최종 결과값 ", this.visible);
                            }else{

                              this.service.userMembernumChecker(item.membernum,item.company.id).subscribe(
                                value =>{
                                  if(value != 'OK'){
                                    alert(value);
                                    this.visible = true;
                                  }else{
                                    this.visible = false;
                                    this.onSubmit.emit(item);
                                    //this.logger.debug("최종 결과값 ", this.visible);
                                  }
                                },
                                error => {
                                  this.logger.error("-- error : " + error);
                                }
                              )

                            }
                            this.logger.info("-- complate : ");
                          }
                        )
                      }else{
                        alert(this.translate.instant('MESSAGE_Enter_Password'));
                      }
                  }
                },
                error => {
                  this.logger.error("-- error : " + error);
                }
              )
            }else{
              return alert(this.translate.instant('MESSAGE_Enter_ID'));
            }

          }else{
            if(item.password != ""){

              let encodePassword = btoa(this.passw);

              this.service.passwordChecker(encodePassword).subscribe(
                value => {
                  this.passwordCheckResult = value;
                  this.logger.debug("-- result :", this.passwordCheckResult);
                },
                error => {
                  this.logger.error("-- error : " + error);
                },
                () => {
                  if(this.passwordCheckResult != 'OK'){
                    alert(this.passwordCheckResult);
                    this.visible = true;
                    //this.logger.debug("최종 결과값 ", this.visible);
                  }else{
                    this.visible = false;
                    item.username = this.username;       // disable을 하면 form에서 못가져와서 직접 추가해줘야함
                    this.onSubmit.emit(item);
                    //this.logger.debug("최종 결과값 ", this.visible);
                  }
                  this.logger.info("-- complate : ");
                }
              )

            }else{
              item.username = this.username;      // disable을 하면 form에서 못가져와서 직접 추가해줘야함
              this.onSubmit.emit(item);
              this.visible = false;
            }

          }
        }else{
            alert(this.translate.instant('MESSAGE_One_Attribute_Required'));
            this.visible = true;
        }

    }
    private onNo():void{
        console.log("================= on no start ============== ")
        this.visible = false;
        console.log("drop box :" , this.drop);
        this.drop.optionsToDisplay = this.drop.options;
        
    }
    ngOnInit(): void {
      
      //this.getAttributeTypeList(1,0,999);
      //this.getAttributeTypeAllList(1);
    }


    

    ngOnChanges(): void {

      this.drop.optionsToDisplay = this.drop.options;
      this.drop.selectedOption = null;
      
      this.passw = "";
      this.passConfirm = "";
      this.username = "";
      this.passConfirmCheck = "";
      if(this.type == "add"){
          console.log("addaddaddaddaddadd");
          this.addForm.reset();
          this.addForm.get('id').setValue('');
          this.addForm.get('username').enable();
          this.addForm.get('username').setValue('');
          this.addForm.get('membernum').setValue('');
          this.addForm.get('email').setValue('');
          this.addForm.get('deptName').setValue('');
          this.addForm.get('name').setValue('');
          this.addForm.get('isUse').setValue('USE');
          this.addForm.get('deptCode').setValue('');
          this.updateDisable = false;
          let compId = "";
          this.selectedCompany.forEach(item => {
            this.addForm.get('company').setValue(item.value);
            compId = item.value.id;
          });

          this.tempItem = [];
          /*this.addForm.get('username').enable();
          this.addForm.get('membernum').enable();
          this.addForm.get('company').enable();
          this.addForm.get('password').enable();
          this.addForm.get('passwordConfirm').enable();
          this.addForm.get('name').enable();
          this.addForm.get('email').enable();
          this.addForm.get('isUse').enable();*/

          var url = "/mgr/system/attribute/type";
          var params = new URLSearchParams();
          this.logger.debug("selectedCompany",this.selectedCompany);

          params.set('companyId', compId);
          this.service.get(url,null,params).subscribe(
            types => {
              this.logger.debug("Value list", types);
              this.typeItems = types;
              this.dynamicAdd(types);
              var type_name:string = "";

              this.typeItems.forEach(item => {
                 this.addForm.get(item.name).enable();
                 this.addForm.get(item.name).setValue('');
              });

              if(types && types.length > 0){
                types.forEach( type => {

                  var atv=[];
                  atv.push({label:"------------",value:''});
                  var param = new URLSearchParams();

                  param.set('attId', type.id);
                  this.service.get("/mgr/system/attribute/value/all",null,param).subscribe(
                    values=>{
                      values.forEach((atv_value ,index)=>{
                        if(atv_value.type=="VALUE"){
                          //this.logger.debug("value", atv_value);
                          atv.push({label:atv_value.name,value:atv_value});

                        }
                      })
                    }
                  )
                  this.tempItem.push({label:type.name,value:atv,controlName:type.name});
                  this.addForm.addControl(type.name, new FormControl(''));
                });
              }

              //this.logger.debug("확인 tempItem",this.tempItem);

            });

          for(let name in this.addForm.controls) {
              (<FormControl>this.addForm.controls[name]).enable();
          }


      }else {
        console.log("======================")
        console.log("update start");
        console.log("======================");
        this.updateDisable = true;
        // console.log("1 detail user:" , this.selectedDetailUser);
        if(this.selectedDetailUser != null) {
          // this.logger.debug("selectedUser",this.selectedDetailUser);
          this.tempItem = [];


          //해당 유저의 속성.!!!!
          this.selectedAttributes = [];
          this.logger.debug("id",this.selectedDetailUser.id);
          this.service.getUserAttributeValueLists(this.selectedDetailUser.id).subscribe(
            value=>{
              value.forEach(item => {
                this.selectedAttributes.push({label: item.label, value:item});
              })
              this.logger.debug("selectedAttributes",this.selectedAttributes);
            },
            error => {this.logger.error("-- error : " + error); },
            ()=> {


              //전체 속성 만드는 곳
              var url = "/mgr/system/attribute/type";
              var params = new URLSearchParams();
              params.set('companyId', this.selectedDetailUser.company.id);
              this.service.get(url,null,params).subscribe(
                types => {
                  this.typeItems = types;
                  this.dynamicAdd(types);
                  this.logger.debug("Value list", types);
                  //자세히면 전부 disable
                  if(this.type=="detail"){
                      for(let name in this.addForm.controls) {
                          (<FormControl>this.addForm.controls[name]).disable();
                      }
                      if(this.typeItems && this.typeItems.length>0){
                          this.typeItems.forEach(item => {
                              this.addForm.get(item.name).disable();
                              this.addForm.get(item.name).setValue('');
                          });
                      }

                  } else{
                      //수정이면 전부 enable
                      this.updateDisable = true;
                      for(let name in this.addForm.controls) {
                          (<FormControl>this.addForm.controls[name]).enable();
                          if(name=="username") (<FormControl>this.addForm.controls[name]).disable();
                      }
                      if(this.typeItems && this.typeItems.length>0){
                          this.typeItems.forEach(item => {
                              this.addForm.get(item.name).enable();
                              this.addForm.get(item.name).setValue('');
                          });
                      }
                  }

                  var type_name:string = "";
                  if(types && types.length > 0){
                    types.forEach( type => {
                      //this.addForm.addControl(type.name, new FormControl(''));
                      var atv=[];
                      atv.push({label:"------------",value:''});
                      var param = new URLSearchParams();
                      param.set('attId', type.id);
                      this.service.get("/mgr/system/attribute/value/all",null,param).subscribe(
                        values=>{
                          values.forEach(atv_value =>{
                            if(atv_value.type=="VALUE"){

                              if(this.selectedAttributes && this.selectedAttributes.length > 0){
                                this.selectedAttributes.forEach(item => {

                                  if(item.label == atv_value.name){
                                    //this.logger.debug("waht form",this.addForm.get(type.name));
                                    //this.addForm.controls(item.label).setValue(atv_value);
                                    this.addForm.get(type.name).setValue(atv_value);

                                  }
                                })
                              }
                              this.logger.debug("atv_value",atv_value);
                              atv.push({label:atv_value.name,value:atv_value});
                            }
                          })
                        }
                      );
                      //this.addForm.addControl(type.name, new FormControl(''));
                      this.tempItem.push({label:type.name,value:atv,controlName:type.name});
                      //this.addForm.get(type.name).setValue();
                    });
                  }

                  this.logger.debug("확인 tempItem",this.tempItem);

                }, error => {this.logger.error("-- error : " + error); },
                () =>{});

            }
          );


          // console.log("selected detaul user :", this.selectedDetailUser);
          // console.log("dcode :" , this.selectedDetailUser.dCode);
          this.username = this.selectedDetailUser.username;
          this.addForm.get('id').setValue(this.selectedDetailUser.id);
          this.addForm.get('username').setValue(this.selectedDetailUser.username);
          this.addForm.get('membernum').setValue(this.selectedDetailUser.membernum);
          this.addForm.get('email').setValue(this.selectedDetailUser.email);
          this.addForm.get('deptName').setValue('');
          this.addForm.get('name').setValue(this.selectedDetailUser.name);
          this.addForm.get('isUse').setValue(this.selectedDetailUser.isUse);
          this.addForm.get('company').setValue(this.selectedDetailUser.company);
          console.log(this.selectedDetailUser);
          //console.log(this.insaDeptCode);
          //console.log(this.selectedCompany);
          this.addForm.get('deptCode').setValue(this.selectedDetailUser.dCode);

        }

      }


    }

  dynamicAdd(item:any){
      console.log("dynamicAdd ", item);
      if(item){
        item.forEach(val => {
          this.addForm.addControl(val.name, new FormControl(''));
          //this.addForm.get(val.name).enable();
        });

      }
  }

    userNameChecker(username:string){
      this.logger.debug("username : ",username);
      this.service.userNameChecker(username).subscribe(
        value => {
          this.logger.debug("usernameCheck 결과 값 : ",value);
          if(value != "OK"){
            alert(this.translate.instant('MESSAGE_Duplicate_ID'));
          }
        },
        error => {
          this.logger.error("-- error : " + error);
        }
      )
    }

    passwordChecker(password:string) {
      this.logger.debug("btoa" ,btoa(password));
      let encodePassword = btoa(password);

      //Base64.encode(password);
      this.service.passwordChecker(encodePassword).subscribe(
        value => {
          this.passwordCheckResult = value;
          this.logger.debug("-- result :", this.passwordCheckResult);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          if(this.passwordCheckResult != 'OK'){
            return this.passwordCheckResult;
          }
          this.logger.info("-- complate : ");
        }
      )
    }

    passwordCheck() {
      if(this.passw != this.passConfirm){
        this.passConfirmCheck = this.translate.instant('MESSAGE_Password_Check_Again');
      }else{
        this.passConfirmCheck = "";
      }
    }

    /*onChangeCompany(event) {
      let attrName = [];
      this.tempItem = [];
      this.selectCompany = event.value;
      this.logger.debug("selectCompany :" , this.selectCompany);
      var url = "/mgr/system/attribute/type";
      var params = new URLSearchParams();
      params.set('companyId', this.selectCompany.id);
      this.service.get(url,null,params).subscribe(
        types => {
            this.logger.debug("Value list", types);
            this.dynamicAdd(types);
            var type_name:string = "";
            if(types && types.length > 0){
              types.forEach( type => {

                var atv=[];
                var param = new URLSearchParams();
                param.set('attId', type.id);
                this.service.get("/mgr/system/attribute/value/all",null,param).subscribe(
                    values=>{
                        values.forEach(atv_value =>{
                            if(atv_value.type=="VALUE"){
                                //this.logger.debug("value", atv_value);
                                atv.push({label:atv_value.name,value:atv_value});
                            }
                        })
                    }
                )

                this.tempItem.push({label:type.name,value:atv,controlName:type.name});
                this.addForm.addControl(type.name, new FormControl(''));
            });
          }

            //this.logger.debug("확인 tempItem",this.tempItem);

        }, error => {this.logger.error("-- error : " + error); });
    }*/
    getAttributeTypeAllList(companyId : number){
        this.service.getAttributeTypeAllList(companyId).subscribe(
          value => {
            this.logger.debug("TypeAllList value", value);
          },
          error => {
            this.logger.error("-- error : " + error);
          }
        )
    }

    getAttributeValueTree(attId : number){
        //this.ttts = [];
        let childItem: any[];
        this.service.getAttributeValueTree(attId).subscribe(
          value => {
            this.logger.debug("attributeValueTree value", value);
            //this.ttts.push({label : '--'+value.name,value: value.id});
            this.childItem =[];
            if(value.children && value.children.length >0){
                this.childAttribute(value.children);
            }

            this.tempItem.push({label:value.name,value:this.childItem});

            this.logger.debug("tempItem",this.tempItem);

          },
          error => {
            this.logger.error("-- error : " + error);
          }
        )
    }

    childAttribute(item){
      this.logger.debug( " childAttributeItem",item);

      item.forEach(item => {
        if(item.children && item.children.length >0){
          this.childItem.push({label : "-"+item.name,value: item.id});
          this.childAttribute(item.children);
        }else{
          this.childItem.push({label : item.name,value: item.id});
        }
      })


    }

    getInsaDeptCode(){
        this.service.getInsaDeptCode().subscribe(
            value => {
                if(value && value.length>0){
                    value.forEach(item => {
                        this.insaDeptCode.push({label:item.name,value:item.code});
                    });

                }
                console.log(value);

            },
            error => {
                this.logger.error("-- error : " + error);
            }
        )
    }

   
    onDropDownFocus(dropdown) {
      dropdown.selectedOption = null;
      dropdown.optionsToDisplay = dropdown.options;
      let dropdownValue = dropdown.filterViewChild.nativeElement.value;
      if(dropdownValue) {
        console.log("clear!!!!");
        dropdown.filterViewChild.nativeElement.value = null;
        dropdown.selectedOptionUpdated = true;
      }
    }
}


@NgModule({
    imports:[DialogModule,BrowserModule,ButtonModule,FormsModule,DropdownModule,ReactiveFormsModule,CommonModule,BrowserModule,HttpModule,InputTextModule,PanelModule, TranslatePipeMoudle],
    declarations:[ExUserDialogComponent],
    exports:[ExUserDialogComponent],
    providers:[MamAdminService]
})
export class ExUserDialogModule{

}



// WEBPACK FOOTER //
// ./src/app/component/user_dlg.component.ts